module.exports = __webpack_public_path__ + "static/media/Ziplyne-on-WorkDay.656a0db0.webm";